(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initUgc(root) {
    if (!root || root.dataset.mgUgcReady === 'true') return;
    root.dataset.mgUgcReady = 'true';
    const viewport = root.querySelector('[data-mg-ugc-viewport]');
    const previous = root.querySelector('[data-mg-ugc-prev]');
    const next = root.querySelector('[data-mg-ugc-next]');
    if (!viewport) return;
    const track = viewport.querySelector('.mg-community-wall__track');
    const step = () => Math.max(266, Math.min(320, viewport.clientWidth * .78));
    let animationFrame = 0;
    let tickerFrame = 0;
    let paused = false;
    let lastTime = 0;
    let loopWidth = 0;

    const animateTo = (target) => {
      window.cancelAnimationFrame(animationFrame);
      const startLeft = viewport.scrollLeft;
      const distance = target - startLeft;
      const startTime = performance.now();
      const frame = (now) => {
        const progress = Math.min(1, (now - startTime) / 720);
        const eased = 1 - Math.pow(1 - progress, 4);
        viewport.scrollLeft = startLeft + distance * eased;
        if (progress < 1) animationFrame = window.requestAnimationFrame(frame);
      };
      animationFrame = window.requestAnimationFrame(frame);
    };
    const move = (direction) => animateTo(viewport.scrollLeft + step() * direction);
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    if (reduceMotion || !track) return;

    Array.from(track.children).forEach((card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.append(clone);
    });
    const measure = () => { loopWidth = track.scrollWidth / 2; };
    measure();
    window.addEventListener('resize', measure, { passive: true });

    const tick = (now) => {
      if (!lastTime) lastTime = now;
      const delta = Math.min(34, now - lastTime);
      lastTime = now;
      if (!paused && !document.hidden) {
        viewport.scrollLeft += delta * .025;
        if (loopWidth && viewport.scrollLeft >= loopWidth) viewport.scrollLeft -= loopWidth;
      }
      tickerFrame = window.requestAnimationFrame(tick);
    };
    const stop = () => { paused = true; };
    const start = () => { paused = false; lastTime = performance.now(); };
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    root.addEventListener('pointerdown', stop);
    window.addEventListener('pointerup', start, { passive: true });
    tickerFrame = window.requestAnimationFrame(tick);
    root.addEventListener('shopify:section:unload', () => window.cancelAnimationFrame(tickerFrame), { once: true });
  }

  function initSocial(root) {
    if (!root || root.dataset.mgSocialReady === 'true') return;
    root.dataset.mgSocialReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-mg-social-tab]'));
    const videos = Array.from(root.querySelectorAll('[data-mg-social-video]'));
    const activate = (name, shouldPlay = true) => {
      tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.mgSocialTab === name)));
      videos.forEach((video) => {
        const active = video.dataset.mgSocialVideo === name;
        video.classList.toggle('is-active', active);
        if (!active) video.pause();
        else if (shouldPlay && !reduceMotion) video.play().catch(() => {});
      });
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.mgSocialTab)));
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.some((entry) => entry.isIntersecting);
      const active = root.querySelector('[data-mg-social-video].is-active');
      if (!active) return;
      if (visible && !reduceMotion) active.play().catch(() => {});
      else active.pause();
    }, { threshold: .35 });
    observer.observe(root);
    activate('tiktok', false);

    const endpoint = root.dataset.mgSocialStatsEndpoint;
    if (endpoint) {
      fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Statistiche social non disponibili');
          return response.json();
        })
        .then((stats) => {
          const read = (path) => path.split('.').reduce((value, key) => value && value[key], stats);
          root.querySelectorAll('[data-mg-social-stat]').forEach((element) => {
            const value = Number(read(element.dataset.mgSocialStat));
            if (Number.isFinite(value) && value >= 0) element.textContent = new Intl.NumberFormat('it-IT').format(value);
          });
          root.dataset.mgSocialStatsLive = 'true';
        })
        .catch(() => { root.dataset.mgSocialStatsLive = 'false'; });
    }
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-mg-ugc]').forEach(initUgc);
    scope.querySelectorAll('[data-mg-social]').forEach(initSocial);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

